import Swiper from 'swiper';

const productPage = $('#product').length;
const banner = $('#productBanner');
const gallery = $('#gallerySlider');

export function productsFunc() {
  if (productPage) {
    if (banner) {
      let bannerSwiper, bannerOptions;
      bannerSwiper = undefined;
      bannerOptions = {
        loop: true,
        speed: 800,
        effect: 'slide',
        normalizeSlideIndex: true,
        paginationClickable: true,
        centeredSlides: true,
        slidesPerView: 1,
        navigation: {
          nextEl: '.bannerNext',
          prevEl: '.bannerPrev',
        },
        preloadImages: false,
        lazy: {
          elementClass: 'lazyload',
          loadPrevNextAmount: 2,
          loadPrevNext: true
        }
      };

      function initBannerSwiper() {
        bannerSwiper = new Swiper('#productBanner', bannerOptions);
      }
      initBannerSwiper();
    }
    if (gallery) {
      let gallerySwiper, galleryOptions;
      gallerySwiper = undefined;
      galleryOptions = {
        loop: true,
        speed: 800,
        effect: 'slide',
        normalizeSlideIndex: true,
        paginationClickable: true,
        centeredSlides: true,
        slidesPerView: 1,
        loopAdditionalSlides: 1,
        navigation: {
          nextEl: '.galleryNext',
          prevEl: '.galleryPrev',
        },
        preloadImages: false,
        lazy: {
          elementClass: 'lazyload',
          loadPrevNextAmount: 2,
          loadPrevNext: true
        },
        breakpoints: {
          751: {
            spaceBetween: 60
          },
          320: {
            spaceBetween: 20
          }
        }
      };
  

      function initGallerySwiper() {
        gallerySwiper = new Swiper('#gallerySlider', galleryOptions);
      }
      initGallerySwiper();
    }
    
      $(".productSingleFaqAnswer").hide();
      $(".productSingleFaqQuestion").click(function() {
        var $acordion = "#" + $(this).attr('data-target');
        $($acordion).slideToggle(300);
        $(this).toggleClass("open");
        return false;
      });
      
  if(location.hash !== ""){
      $('header').addClass('changeHeight');
      let resizecheck = $('#responsibleCheck').width();
      let headerHeight = $('header').outerHeight(true);
      var faqPos = $('.faqPos');
      var faqWrap = $('.productSingleFaqWrap');
      var spPos = -headerHeight;
      var hasGallery = $('.productSingleGallery').length;
      console.log(hasGallery);
      if(resizecheck == '1'){
        $('.faqPos').css('top' , '0');
      } else {
        if($('.productSingleFaqWrap').hasClass('hasBg')) {
          $('.faqPos').css('top' , spPos - 70);
        } else {
          $('.faqPos').css('top' , spPos - 50);
        }
        if (hasGallery != 0) {
           $('.faqPos').css('top' , spPos + 100);
        }
      }
  }

  $(window).on('load', function() {
    let scrTop = $(window).scrollTop();
    let headerHeight = $('header').outerHeight(true);
    var hash = window.location.hash;
    var position = $(hash).offset().top - headerHeight;
    var pos = position - headerHeight - 30;
    function scroll(position){
      $('html, body').animate({
        scrollTop : position
      }, 100);
    }
    scroll(pos);
  });
  }
}
